module.exports = __webpack_public_path__ + "static/img/45523534.9d3fd71.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/Images/45523534.jpeg
// module id = tbx8
// module chunks = 1